module.exports = __webpack_public_path__ + "static/img/wechat-bg.c2c7614.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/wechat/wechat-bg.png
// module id = t2DH
// module chunks = 1